import React, { useState } from 'react';
import { isEmpty, partition, propEq } from 'ramda';
import { CaretDownOutlined, CaretRightOutlined, ContainerFilled } from '@ant-design/icons';
import { Collapse } from 'antd';
import { Actions } from '../../components';
import Title from '../../components/Title';
import withUser from '../../withUser';
import { getOfferIdsByUserTeam } from '../helpers/getOfferIdsByUserTeam';
import EmptyOffers from '../errors/EmptyOffers';
import useFetchQuery from '../../hooks/useFetchQuery';
import { QOffersQuery } from '../../_graphql/queries/QOffers';
import Loading from '../../components/Loading';
import OfferList from './offerList/OfferList';
const { Panel } = Collapse;

const Offers = ({ userIsAdmin, userIsSuperAdmin, userTeam }) => {
  const [showArchivedOffers, setShowArchivedOffers] = useState(false);
  const userCanEdit = userIsSuperAdmin || userIsAdmin;

  const offerIds = getOfferIdsByUserTeam(userTeam);
  const { offers, isLoading: isLoadingOffers, reFetch } = useFetchQuery({
    query: QOffersQuery,
    args: { filter: { offerIds: isEmpty(offerIds) ? [] : offerIds } },
    dataProp: 'offers',
    defaultData: [],
    subscribeToStore: true
  });
  
  const [archivedOffers, nonArchivedOffers] = partition(propEq(true, 'isArchived'), offers);

  if (isLoadingOffers) return <Loading />;

  if (!isLoadingOffers && isEmpty(nonArchivedOffers) && !userCanEdit) {
    return <EmptyOffers />;
  }
  
  return (
    <>
      {userCanEdit && (
        <Actions
          listEmpty={isEmpty(offers)}
          actions={[
            {
              label: 'Créer une offre',
              to: '/offre/creer'
            }
          ]}
          title={(
            <Title
              title="mes offres"
              icon="/images/icon-offre-dark@2x.png"
              iconSize={[21, 18]}
              iconOffset={-2}
            />
          )}
        />
      )}
      <OfferList userCanEdit={userCanEdit} offers={nonArchivedOffers} setRefetch={reFetch} />

      {userCanEdit && (
        <div className="mt-4" >
          <Collapse
            activeKey={showArchivedOffers ? ['archives'] : []}
            onChange={(activeKeys) => setShowArchivedOffers(activeKeys.includes('archives'))}
            ghost
            bordered={false}
            className="offers-archives-collapse"
            collapsible={isEmpty(archivedOffers) ? 'disabled' : 'header'}
          >
            <Panel
              key="archives"
              showArrow={false}
              header={(
                <Title
                  title="Archives"
                  titleClassName={isEmpty(archivedOffers) ? 'text-gray-400' : ''}
                  infoTitle={() => isEmpty(archivedOffers) && <span className="text-gray-400 text-sm normal-case font-normal ml-1">(vide)</span>}
                  icon={<ContainerFilled />}
                  iconSize={[21, 18]}
                  iconOffset={-2}
                  afterIcon={(
                    <span className="mr-10px inline-flex items-center">
                      {showArchivedOffers ? <CaretDownOutlined /> : <CaretRightOutlined />}
                    </span>
                  )}
                />
              )}
            >
              <OfferList userCanEdit={userCanEdit} offers={archivedOffers} setRefetch={reFetch} />
            </Panel>
          </Collapse>
        </div>
      )}
    </>
  );
};

export default withUser(Offers);
